import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  CircularProgress
} from '@mui/material';
import api, { influencerAPI } from '../../services/api/apiService';
import { useImages } from '../../context/images/ImagesContext';
import { useServices } from '../../context/services/ServicesContext';
import { useAuth } from '../../context/auth/CognitoAuthContext';

const InfluencerSelector = () => {
  const { selectedInfluencer, setSelectedInfluencer } = useImages();
  const { isAuthenticated, session } = useAuth();
  const { influencerService } = useServices();
  const [influencers, setInfluencers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      fetchInfluencers();
    }
  }, [isAuthenticated]);

  const fetchInfluencers = async () => {
    setLoading(true);
    setError(null);
    
    try {
      // Use the new influencerService to get all influencers
      const data = await influencerService.getAll();
      setInfluencers(data);
      
      // If there are influencers and none is selected, select the first one
      if (data.length > 0 && !selectedInfluencer) {
        setSelectedInfluencer(data[0]);
      }
    } catch (error) {
      console.error('Error fetching influencers:', error);
      setError('Failed to load influencers. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    const influencerId = event.target.value;
    const selected = influencers.find(inf => inf.id === influencerId);
    if (selected) {
      setSelectedInfluencer(selected);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      </Box>
    );
  }

  if (influencers.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2">
          No influencers available. Please add an influencer first.
        </Typography>
      </Box>
    );
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="influencer-select-label">Select Influencer</InputLabel>
      <Select
        labelId="influencer-select-label"
        id="influencer-select"
        value={selectedInfluencer?.id || ''}
        label="Select Influencer"
        onChange={handleChange}
      >
        {influencers.map((influencer) => (
          <MenuItem key={influencer.id} value={influencer.id}>
            {influencer.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default InfluencerSelector;
